<script>
import {
  PART_INFO_FIELD_COUNT,
  PART_COMMENT_FIELD_COUNT,
} from "./itemCardConfig";

export default {
  props: {
    part: { type: Object, required: true },
    config: { type: Object, default: null },
    selectable: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
  },
  computed: {
    extraRows() {
      const rows = [
        {
          key: "partDimensions",
          label: this.$t("general.dimensions"),
          value:
            this.part.width || this.part.height || this.part.depth
              ? `${this.part.width || 0} × ${this.part.height || 0} × ${
                  this.part.depth || 0
                }`
              : null,
        },
        {
          key: "partMaterial",
          label: this.$t("general.material"),
          value: this.part.material,
        },
        ...Array.from({ length: PART_INFO_FIELD_COUNT }, (_, i) => ({
          key: "partInfo" + (i + 1),
          label: `${this.$t("general.info")} ${i + 1}`,
          value: this.part["info" + (i + 1)],
        })),
        ...Array.from({ length: PART_COMMENT_FIELD_COUNT }, (_, i) => ({
          key: "partComment" + (i + 1),
          label: `${this.$t("general.comment")} ${i + 1}`,
          value: this.part["comment" + (i + 1)],
        })),
      ];
      return rows.filter(
        (r) => (r.value || r.value === 0) && this.fieldVisible(r.key),
      );
    },
  },
  methods: {
    fieldVisible(key) {
      return this.config?.visibleFields?.[key] !== false;
    },
    onToggle() {
      this.$emit("toggle");
    },
  },
};
</script>
<template>
  <div
    class="pcard"
    :class="{ selectable, checked: selectable && checked }"
    @click="selectable ? onToggle() : null"
  >
    <div class="pmain">
      <div class="pico">
        <i class="mdi mdi-puzzle-outline"></i>
      </div>
      <div class="pinfo">
        <div class="pname">{{ part.name }}</div>
      </div>
      <div class="pright">
        <span
          v-if="!selectable && part.isDamaged"
          class="pbubble pbubble-dmg"
        >
          <i class="mdi mdi-alert-outline"></i>
        </span>
        <span
          v-if="!selectable && part.isBackOrder"
          class="pbubble pbubble-bo"
        >
          <i class="mdi mdi-minus-circle-outline"></i>
        </span>
        <span
          v-if="selectable"
          class="chkbox"
          :class="{ checked }"
          role="button"
          @click.stop="onToggle"
        >
          <i class="mdi mdi-check" v-if="checked"></i>
        </span>
      </div>
    </div>
    <div class="pextra" v-if="extraRows.length">
      <div class="exrow" v-for="row in extraRows" :key="row.key">
        <span class="exlbl">{{ row.label }}</span>
        <span class="exval">{{ row.value }}</span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.pcard {
  background: white;
  border-radius: 9px;
  border: 1px solid #e0e5ea;
  overflow: hidden;
}
.pcard.selectable {
  cursor: pointer;
}
.pcard.checked {
  background: #e6faf3;
  border-color: #a9dfc3;
}
.pmain {
  padding: 7px 9px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.pico {
  width: 26px;
  height: 26px;
  background: #f0f4f7;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7a8a99;
  font-size: 14px;
  flex-shrink: 0;
}
.pcard.checked .pico {
  background: rgba(52, 195, 143, 0.12);
  color: #34c38f;
}
.pinfo {
  flex: 1;
  min-width: 0;
}
.pname {
  font-size: 12px;
  font-weight: 600;
  color: #1c2e3e;
}
.pright {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}
.pbubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  font-size: 13px;
}
.pbubble-dmg {
  background: #fff8e1;
  color: #f1b44c;
  border: 1px solid #f9d77e;
}
.pbubble-bo {
  background: #fdecea;
  color: #e74c3c;
  border: 1px solid #f9bdbd;
}
.chkbox {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 1.5px solid #e0e5ea;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: transparent;
}
.chkbox.checked {
  background: #34c38f;
  border-color: #34c38f;
  color: white;
}
.pextra {
  border-top: 1px solid #e0e5ea;
  padding: 6px 9px;
  background: rgba(0, 0, 0, 0.012);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pcard.checked .pextra {
  border-top-color: #a9dfc3;
  background: rgba(52, 195, 143, 0.04);
}
.exrow {
  display: flex;
  gap: 7px;
  align-items: flex-start;
}
.exlbl {
  font-size: 10px;
  color: #7a8a99;
  min-width: 74px;
  flex-shrink: 0;
  margin-top: 1px;
}
.exval {
  font-size: 11px;
  color: #1c2e3e;
  flex: 1;
  font-weight: 500;
}
</style>
